import { useEffect, useState } from "react";
import {
  SistemaCadastroDto,
  SistemaFiltrarDto,
  SubModuloEnum,
  TipoConfiguracaoEnum,
} from "../../Configuracoes/Sistema/Sistema.Dto";
import { AutenticacaoModule } from "src/Contexto/auth";
import { ConfiguracaoFiltrar } from "src/services/Fiscal.Service";

const CTeConfiguracaoCode = () => {
  const [configuracao, setConfiguracao] = useState<SistemaCadastroDto[]>([]);
  const [loading, setLoading] = useState(false);
  const { userId } = AutenticacaoModule();

  const CACHE_KEY = "cteConfiguracoes" + userId;
  const CACHE_EXPIRATION_TIME = 30 * 60 * 1000;

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      const cachedData = localStorage.getItem(CACHE_KEY);

      if (cachedData) {
        const parsedData = JSON.parse(cachedData);
        const currentTime = new Date().getTime();

        if (currentTime - parsedData.timestamp < CACHE_EXPIRATION_TIME) {
          setConfiguracao(parsedData.data);
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }
      const input: SistemaFiltrarDto = {
        subModulo: SubModuloEnum.CTe,
        usuarioId: userId.toString(),
      };

      await ConfiguracaoFiltrar(input)
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data as SistemaCadastroDto[];
            const cacheObject = {
              data,
              timestamp: new Date().getTime(),
            };
            localStorage.setItem(CACHE_KEY, JSON.stringify(cacheObject));
            setConfiguracao(data);
          } else {
            console.error(response);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [userId]);

  const getConfiguracaoValor = (tipo: TipoConfiguracaoEnum) => {
    const item = configuracao.find(
      (item) => String(item.tipoConfiguracao) === String(tipo)
    );
    return item ? item.configuracaoValor : "1";
  };

  return {
    configuracao,
    loading,
    getConfiguracaoValor,
  };
};

export default CTeConfiguracaoCode;
